export const DEFAULT_AGENT_DISPLAY_NAME = "SurveyLoop";
export const ALPHA_AGENT_DISPLAY_NAME = "SurveyLoopAlpha";

type AgentBrandingEnv = {
  STAGE?: string;
  NEXT_PUBLIC_STAGE?: string;
  PUBLIC_APP_URL?: string;
  NEXT_PUBLIC_SITE_URL?: string;
};

function runtimeAgentBrandingEnv(): AgentBrandingEnv {
  return {
    // Keep public variables as direct property reads so Next can inline them
    // into the client bundle instead of leaving a dynamic process.env lookup.
    NEXT_PUBLIC_STAGE: process.env.NEXT_PUBLIC_STAGE,
    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    STAGE: typeof window === "undefined" ? process.env.STAGE : undefined,
    PUBLIC_APP_URL:
      typeof window === "undefined" ? process.env.PUBLIC_APP_URL : undefined,
  };
}

export function resolveAgentDisplayName(env?: AgentBrandingEnv) {
  const resolvedEnv = env || runtimeAgentBrandingEnv();
  const stage = (
    resolvedEnv.NEXT_PUBLIC_STAGE ||
    resolvedEnv.STAGE ||
    ""
  ).toLowerCase();
  const publicUrl = (
    resolvedEnv.NEXT_PUBLIC_SITE_URL ||
    resolvedEnv.PUBLIC_APP_URL ||
    ""
  ).toLowerCase();
  if (stage === "alpha" || publicUrl.includes("alpha.")) {
    return ALPHA_AGENT_DISPLAY_NAME;
  }

  return DEFAULT_AGENT_DISPLAY_NAME;
}
